import React, {useEffect} from 'react';

import Transition from '../assets/Transition';
import Header from '../components/Header';
import ProjectsGrid from '../components/Project/ProjectsGrid';
import About from "../components/About";
import ContactForm from "../components/ContactForm";

import Image from '../assets/projects.webp';

const Projects = () => {
    useEffect(() => {
        document.title = "Projects";
    });
    
    return (
        <div>
            <Header
                title="Projects"
                tagline={ <>A collection of software, products, and experiments <span className='underline'>I've built</span> over the years.</> } 
                image={Image}
                subtitle="ZOTY" />
            <section className="projects">
                
            </section>
            <ProjectsGrid />
            <About />
            <ContactForm />
        </div>
    );
};

export default Transition(Projects);